<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.ocupacoes"
                            default-option-text="Todos"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :disabled="model.ocupacaoId === null"
                            :repository="repositories.relatorioQuantitativoCid"
                            :request-query-string-params="requestQueryStringParams"
                            :search-fields="fields.autocomplete"
                            :text-field="(item) => item.codigo ? `${item.codigo} - ${item.nome}` : ''"
                            label="CID"
                            v-model="model.cid"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.idadeDe"
                            label="Idade de"
                            number
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :validations="validations.idadeAte"
                            label="Idade até"
                            number
                            v-model="model.idadeAte"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields.table"
                    :items="data.itens"
                    hide-pagination
                    sort-by="cid"
                />
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        requestQueryStringParams() {
            return {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                ocupacao_id: this.model.ocupacaoId,
            }
        },
        validations() {
            return {
                periodo: {required: true},
                idadeDe: {
                    max: 3,
                    min_value: 0,
                    max_value: this.model.idadeAte ? this.model.idadeDe : 999,
                },
                idadeAte: {
                    max: 3,
                    min_value: this.model.idadeDe ? this.model.idadeDe : 0,
                    max_value: 999,
                },
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            relatorioQuantitativoCid: this.getConectaSusRepository('ambulatorio.relatorioQuantitativoCid'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            fields: {
                autocomplete: [
                    {key: 'cid.codigo', searchable: true},
                    {key: 'cid.nome', searchable: true},
                ],
                table: [
                    {key: 'cid', label: 'CID', sortable: true},
                    {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                    {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                    {key: 'quantidade', label: 'Quantidade', sortable: true},
                ],
            },
            data: null,
            model: null,
            others: {moment},
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioQuantitativoCid.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                cidId: this.model.cid ? this.model.cid.id : null,
                idadeDe: this.model.idadeDe,
                idadeAte: this.model.idadeAte,
            }

            this.setLoading()

            this.repositories.relatorioQuantitativoCid.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.ocupacoes = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.cid = null
            this.model.idadeDe = null
            this.model.idadeAte = null

            this.data = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                ocupacaoId: this.model.ocupacaoId,
                cidId: this.model.cid ? this.model.cid.id : null,
                idadeDe: this.model.idadeDe,
                idadeAte: this.model.idadeAte,
            }

            this.repositories.impressao.relatorioQuantitativoCid(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.cid = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioQuantitativoCid.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.model.ocupacaoId = null
            this.model.cid = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.data = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'ocupacoes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioQuantitativoCid.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.ocupacoes = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.ocupacaoId = null
                this.model.cid = null
                this.model.idadeDe = null
                this.model.idadeAte = null
                this.data = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioQuantitativoCid.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.ocupacoes = Object.assign(response.data.ocupacoes)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>